import { useQuery } from 'apollo-client'

import { useFt } from 'hooks'
import { constants } from 'helpers'
import productGiftPromoQuery from './graph/productGiftPromo.graphql'


export const useProductGiftPromo = () => {
  const isGwpSpendThresholdEnabled = useFt(constants.features.gwpSpendThreshold)

  const { data, isFetching } = useQuery(productGiftPromoQuery, {
    variables: {
      input: {
        offer: 'GIFT_FOR_SUBTOTAL',
      },
    },
    skip: !isGwpSpendThresholdEnabled,
    context: {
      ssrCache: true,
    },
  })

  if (!isGwpSpendThresholdEnabled) {
    return {
      subTotal: null,
      isFetching,
    }
  }

  const subTotal = data?.productGiftPromo?.data?.condition?.subTotal ?? null

  return {
    subTotal,
    isFetching,
  }
}

export default useProductGiftPromo
